import { Grid, makeStyles, Box } from "@material-ui/core";
import React from "react";
import apple from "../assets/apple.svg";

const useStyles = makeStyles((theme) => ({
  heroWrap: {
    backgroundColor: theme.palette.primary.main,
  },
  heroText: {
    fontSize: "5rem",
    padding: ".5rem 3rem",
    fontStyle: "normal",
    fontWeight: "900",
    lineHeight: "4rem",
    letterSpacing: "-0.02em",
    textAlign: "left",
    marginTop: "100px"
  },
  subtitle: {
    fontWeight: " normal",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    letterSpacing: "-0.015em",
  },
  text: {
    color: theme.palette.text.main,
  },
  midText: {
    color: theme.palette.secondary.main,
  },
}));

function Hero() {
  const classes = useStyles();
  return (
    <div className={classes.heroWrap}>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box className={classes.heroText}>
          <h1 className={classes.text}>Smart.</h1>
          <h1 className={classes.midText}>Seamless.</h1>
          <h1 className={classes.text}>Targeted.</h1>
          <p className={classes.subtitle}>
            The First Multi-Chain, Marketing Launchpad based on Trust and
            Transparency.
          </p>
        </Box>
        <Box alignSelf="flex-start" justifySelf="flex-end">
          <img src={apple} alt="" />
        </Box>
      </Box>
    </div>
  );
}

export default Hero;
